// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__SOQHe","header":"styles_header__1ca3U","body":"styles_body__eeHAl","popupWrapper":"styles_popupWrapper__n607d"};